import * as React from 'react';
import * as styles from './AssetTextField.scss';
import { TextField, ITextFieldProps, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { observer } from 'mobx-react-lite';
import TextFieldWithHiddenLabel from './TextFieldWithHiddenLabel';

const primaryStyles: Partial<ITextFieldStyles> = {
    root: styles.primaryRoot,
    field: styles.primaryField,
    fieldGroup: styles.primaryFieldGroup,
};

const secondarySingleLineStyles: Partial<ITextFieldStyles> = {
    root: styles.secondaryRoot,
    field: styles.secondaryField,
    fieldGroup: styles.secondaryFieldGroup,
};

const secondaryMultiLineStyles: Partial<ITextFieldStyles> = {
    root: styles.secondaryRootMultiline,
    field: styles.secondaryFieldMultiLine,
    fieldGroup: styles.secondaryFieldGroupMultiLine,
};

export interface AssetTextFieldProps
    extends Exclude<ITextFieldProps, 'styles' | 'borderless' | 'onPaste'> {
    secondary?: boolean;
    showLabel?: boolean;
}

/** A text field, with the right font size and color to be used in assets. */
export default observer(function AssetTextField(props: AssetTextFieldProps) {
    const styles = props.secondary
        ? props.multiline
            ? secondaryMultiLineStyles
            : secondarySingleLineStyles
        : primaryStyles;

    const View = props.showLabel ? TextField : TextFieldWithHiddenLabel;
    return <View styles={styles} borderless={true} {...props} onPaste={onPaste} />;
});

/**
 * Prevent paste in asset text fields from propagating to the canvas
 * to avoid creating new assets (like links or notes).
 */
function onPaste(e: React.SyntheticEvent) {
    e.stopPropagation();
}
